module.exports = {["template-common-button-widget"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n    <div class="common-button" data-id="'+
((__t=(data._id))==null?'':_.escape(__t))+
'">\n\n        <div class="icon"></div>\n\n    </div>\n\n';
}
return __p;
},}